import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { JobListModel } from '../models/JobListModel';
import { JobModel } from '../models/JobModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';
import { AdvancedFilterModel } from '../models/AdvancedFilterModel';
import { FilterPageViewModel } from '../models/FilterPageViewModel';
import { JobWorkSpacePageViewModel } from '../models/JobWorkSpacePageViewModel';
import { JobExportModel } from '../models/JobExportModel';
import { LookupModel } from '../../common/models/LookupModel';
import * as moment from 'moment'
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { DatabaseJobsModel } from '../models/DatabaseJobsModel';

@Injectable()
export class JobsService {
  constructor(public httpClient: HttpClient,
    private baseAddressInterceptor: BaseAddressInterceptor) {

  }

  getJobList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string, model: AdvancedFilterModel = null): Observable<QueryResponse<JobListModel>> {
    var filterPageViewModel = new FilterPageViewModel();
    filterPageViewModel.skip = page * pageSize;
    filterPageViewModel.take = pageSize;
    filterPageViewModel.sort = sort;
    filterPageViewModel.sortDirection = sortDirection;
    filterPageViewModel.searchTerm = searchTerm;
    if (model != null) {
      filterPageViewModel.model = model;
    }
    return this.httpClient.post<QueryResponse<JobListModel>>("/api/SubmissionModule/Job/ListQuery", filterPageViewModel);
  }

  getJob(model: JobWorkSpacePageViewModel): Observable<ModelResponse<JobModel>> {
    return this.httpClient.post<ModelResponse<JobModel>>("/api/SubmissionModule/Job/Workspace/", model);
  }

  reprocessJobSubmission(key: string): Observable<ModelResponse<string>> {
    return this.httpClient.get<ModelResponse<string>>("/api/SubmissionModule/Job/Reprocess/" + key);
  }

  cancelJobSubmission(key: string, jobKey): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/SubmissionModule/Job/${key}/Cancel/`, { model: jobKey });
  }

  getJobStatuses(): Observable<ModelResponse<LookupModel[]>> {
    return this.httpClient.get<ModelResponse<LookupModel[]>>(`/api/SubmissionModule/Job/GetStatuses`);
  }

  getJobDataSets(): Observable<ModelResponse<LookupModel[]>> {
    return this.httpClient.get<ModelResponse<LookupModel[]>>(`/api/SubmissionModule/Job/GetDataSets`);
  }

  export(model: JobExportModel): Observable<ModelResponse<JobExportModel>> {
    return this.httpClient.post<ModelResponse<JobExportModel>>(`/api/SubmissionModule/Job/ExportUrl/`, model)
      .map(r => {
        r.model.url = this.baseAddressInterceptor.getApiUrl(r.model.url);
        return r;
      });
  }

  openExtract(url: string, model: any): void {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(model).forEach((param) => {
      var value = model[param];
      if (Array.isArray(value)) {
        var select = document.createElement("select");
        select.multiple = true;
        select.name = param;
        value.forEach((v) => {
          var option = document.createElement("option");
          select.add(option);
          option.setAttribute("value", v);
          option.selected = true;
        });
        mapForm.appendChild(select);
      } else {
        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = param;
        if (param.toLowerCase().endsWith("date")) {
          value = value.format();
        }
        mapInput.setAttribute("value", value);
        mapForm.appendChild(mapInput);
      }
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
    setTimeout(() => document.body.removeChild(mapForm), 100);
  }

  triggerDatabaseJobs(model: DatabaseJobsModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/SubmissionModule/Job/TriggerDatabaseJobs`, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/services/JobsService.ts